// uses ./DefaultEditorChooser.less
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../common/Icon';
import Loading from '../../common/Loading';
import t from '../../../translations';
import { Editor, AppId } from '../../common/interfaces';

interface DefaultEditorChooserProps {
    appId: string;
    isLoading: boolean;
    handleChange: (editor: AppId | null) => void;
    topPriorityEditor: Editor | null;
    editorDetails: Editor;
    isTopPriorityEditor: boolean;
}
function DefaultEditorChooser({
    appId,
    isLoading,
    handleChange,
    topPriorityEditor,
    isTopPriorityEditor,
}: DefaultEditorChooserProps) {
    const isToggleTurnedOn = isTopPriorityEditor;

    const defaultAppIdToggleChangeHandler = () => {
        handleChange(isToggleTurnedOn ? null : appId);
    };

    return (
        <div className="ast-app-editors">
            <Loading isLoaded={!isLoading}>
                <div className="ast-app-editors">
                    <span
                        className={`ast-app-editors sg-toggle ${isToggleTurnedOn ? 'sg-toggle--on' : ''}`}
                        onClick={defaultAppIdToggleChangeHandler}
                    />
                    <span className="ast-app-editors__description">Set as default app for editing</span>
                    <span
                        className="ast-app-editors__tooltip"
                        data-tooltip="Default option for “Edit in...” button for domain users"
                    >
                        <Icon alias="info" />
                    </span>

                    {topPriorityEditor && appId !== topPriorityEditor.appId ? (
                        <p className="ast-app-editors__current-app">
                            Current default app: <strong>{topPriorityEditor.name}</strong>
                        </p>
                    ) : null}
                </div>
                {!topPriorityEditor && (
                    <div className="ast-default-app-note__information-box">
                        <Icon alias="alert-circle-o" />
                        <p className="ast-default-app-note__information-text">
                            {t.AppDomainSettings.coEditDefaultTooltip}
                        </p>
                    </div>
                )}
            </Loading>
        </div>
    );
}

DefaultEditorChooser.propTypes = {
    appId: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    currentDefaultApp: PropTypes.object,
    closeHandler: PropTypes.func,
};

export default DefaultEditorChooser;
